import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100vh;
`;

export const RoutesContainer = styled.div`
  display: flex;

  @media (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    flex-direction: column;
  }
`;
